/**
 * WHICH PRODUCT THIS BUILD IS.
 *
 * Two products come out of this codebase, and the difference is the law,
 * not the design.
 *
 *   directory    Saudi Arabia (§79-§81). Qafila publishes WHO IS LICENSED
 *                and hands the traveller to the carrier's own site. It may
 *                not take a request, hold a price, sell a seat, rank a
 *                carrier or notify more than one -- "arranging road
 *                transport activities and services among beneficiaries" is
 *                a licensed activity and that is the list of things it
 *                means. This is the default, so a build that forgets to
 *                set the flag is the SAFE one.
 *
 *   marketplace  elsewhere (§82). The original product: departures, seat
 *                selection, cross-carrier quotes, the open-requests board.
 *                Lawful where intermediation is not licensed like this, and
 *                worthless inside the Kingdom.
 *
 * WHY A FLAG AND NOT A DELETION. §81 planned to delete the marketplace
 * screens outright. §82 reversed it: a frozen branch would miss every later
 * improvement to the design system, the eighteen languages, the payment
 * plumbing and the bug fixes, so the marketplace would rot into a rewrite.
 * One codebase, two modes, and the Saudi build simply does not contain the
 * screens -- `IS_MARKETPLACE` is a build-time constant, so Vite drops the
 * other branch out of the bundle rather than shipping it dark.
 *
 * The other-country app also needs its own name, icon and content: nothing
 * in the Saudi build may appear there, and it must never list a Saudi route
 * or a Saudi carrier. See §82 for the boundary.
 */
export type Market = 'directory' | 'marketplace'

const RAW = (import.meta.env.VITE_MARKET as string | undefined) ?? 'directory'

/** Anything but the explicit opt-in is a directory. Fail closed. */
export const MARKET: Market = RAW === 'marketplace' ? 'marketplace' : 'directory'

/** Saudi Arabia: publish who is licensed, hand off, hold nothing. */
export const IS_DIRECTORY = MARKET === 'directory'
/** Everywhere the original product is lawful. */
export const IS_MARKETPLACE = MARKET === 'marketplace'
